import cisero from "../assets/cisero.png";
import ciseroFull from "../assets/cisero-full.png";

// Cisero — 6zero's mascot (capybara, sunglasses, suit). She/her.
// variant="head" (default) — round avatar crop, for small icon use (chat
// bubbles, spinners, nav). variant="full" — full-body, for prominent
// placements (landing page hero).
export default function Mascot({ size = 48, style, variant = "head" }) {
  const full = variant === "full";
  return (
    <img
      src={full ? ciseroFull : cisero}
      alt="Cisero, the 6zero mascot"
      width={full ? undefined : size}
      height={size}
      style={{
        borderRadius: full ? 0 : "50%",
        objectFit: "cover",
        display: "block",
        ...style,
      }}
    />
  );
}
